import "katex/dist/katex.min.css";
import '../styles/mykatex.css';
import katex from "katex";
import "katex/dist/contrib/copy-tex.min.js";

// Импорт авто-рендеринга
import renderMathInElement from "katex/dist/contrib/auto-render.min.js";

// Настраиваем макросы
const macros = {
  "\\dv": "\\smash{\\mskip3mu\\vdots\\mskip3mu}",
  "\\al": "\\alpha",
  "\\be": "\\beta",
  "\\ga": "\\gamma",
  "\\Ga": "\\Gamma",
  "\\de": "\\delta",
  "\\De": "\\Delta",
  "\\ep": "\\varepsilon",
  "\\ka": "\\varkappa",
  "\\la": "\\lambda",
  "\\La": "\\Lambda",
  "\\si": "\\sigma",
  "\\Sig": "\\Sigma",
  "\\om": "\\omega",
  "\\Om": "\\Omega",
  "\\ph": "\\varphi",
  "\\Ph": "\\Phi",
  "\\rh": "\\rho",
  "\\ta": "\\theta",
  "\\Ta": "\\Theta",
  "\\ze": "\\zeta",
  "\\nab": "\\nabla",
};

// Функция для запуска авто-рендера
export function renderMath(element) {
  renderMathInElement(element || document.body, {
    macros,
    strict: false,
    maxExpand: Infinity,
    output: "html",
    throwOnError: false,
    errorColor: "#f00",
    delimiters: [
      {left: "$$", right: "$$", display: true},
      {left: "\\[", right: "\\]", display: true},
      {left: "$", right: "$", display: false},
      {left: "\\(", right: "\\)", display: false},
    ],
  });
}

document.addEventListener("DOMContentLoaded", () => {
  renderMath();
});
